import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';
import { ICheckmarkItem } from '../../../shared/components/checkmark-list/checkmark-list.component';
import { OnboardingStripeDialogBuilder } from './onboarding-stripe-dialog.builder';
import { List } from 'immutable';
import { NavigationService } from '../../../navigation/navigation.service';
import { URLS } from '../../../shared/constants/urls.constant';
import { LocalStorageService } from '../../../browser-manager-data/local-storage.service';
import { STRIPE_UNDERWRITING_KEY } from '../../../payments-data/payments-data.data';
import {
  TrackingDialogNamesEnum,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { I2gNgTrackingActionBuilder, ITrackingAction } from 'i2g-ng-tracking';

export const DIALOG_TYPE = 'onboarding-stripe';

@Component({
  selector: 'app-onboarding-stripe-dialog',
  templateUrl: './onboarding-stripe-dialog.component.html',
  styleUrls: ['./onboarding-stripe-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [OnboardingStripeDialogBuilder],
})
export class OnboardingStripeDialogComponent implements OnInit {
  @Input() underwritingUrl: string;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  dialogType: string;
  trackingDialogName: TrackingDialogNamesEnum;
  primaryActionTappedTrackingAction: ITrackingAction;
  secondaryActionTappedTrackingAction: ITrackingAction;
  underwritingStripeCanvasIcon: IIcon;
  listItems: List<ICheckmarkItem>;

  constructor(
    private _onboardingStripeDialogBuilder: OnboardingStripeDialogBuilder,
    private _navigationService: NavigationService,
    private _localStorageService: LocalStorageService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.trackingDialogName = TrackingDialogNamesEnum.account_underwrite;
    this.primaryActionTappedTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'link_bank_account',
      this.trackingScreenName
    );
    this.secondaryActionTappedTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'open_help_center',
      this.trackingScreenName
    );
    this.underwritingStripeCanvasIcon = {
      name: 'underwriting-stripe-canvas',
      size: IconSizesEnum.custom,
    };
    this.listItems = this._onboardingStripeDialogBuilder.buildListItems();
  }

  goToStripe() {
    if (this.underwritingUrl) {
      this._localStorageService.setItem(STRIPE_UNDERWRITING_KEY, 'true');

      this._navigationService.goToExternalUrl(this.underwritingUrl, false);
    }
  }

  goToLearnMore() {
    this._navigationService.goToExternalUrl(URLS.PAYMENTS_HELP_CARDS, true);
  }
}
